import { render, staticRenderFns } from "./NavBarM.vue?vue&type=template&id=812cc85e&scoped=true&"
import script from "./NavBarM.vue?vue&type=script&lang=js&"
export * from "./NavBarM.vue?vue&type=script&lang=js&"
import style0 from "./NavBarM.vue?vue&type=style&index=0&id=812cc85e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812cc85e",
  null
  
)

export default component.exports